import { defineRouter } from '#q-app'
import { routes, handleHotUpdate } from 'vue-router/auto-routes'
import {
  createMemoryHistory,
  createRouter,
  createWebHashHistory,
  createWebHistory
} from 'vue-router'
import { LocalStorage } from 'quasar'

/*
 * If not building with SSR mode, you can
 * directly export the Router instantiation;
 *
 * The function below can be async too; either use
 * async/await or return a Promise which resolves
 * with the Router instance.
 */

export default defineRouter((/* { store, ssrContext } */) => {
  const createHistory = import.meta.env.QUASAR_SERVER
    ? createMemoryHistory
    : import.meta.env.QUASAR_VUE_ROUTER_MODE === 'history'
      ? createWebHistory
      : createWebHashHistory

  const Router = createRouter({
    scrollBehavior: () => ({ left: 0, top: 0 }),
    routes,

    // Leave this as is and make changes in quasar.conf.js instead!
    // quasar.conf.js -> build -> vueRouterMode
    // quasar.conf.js -> build -> publicPath
    history: createHistory(import.meta.env.QUASAR_VUE_ROUTER_BASE)
  })

  // enable HMR for it
  if (import.meta.hot) {
    handleHotUpdate(Router)
  }

  Router.beforeEach((to, from, next) => {
    // Assuming you have set meta: { requiresAuth: true } on protected routes
    // and meta: { guest: true } on login/register routes
    const isAuthenticated = !!LocalStorage.getItem('access_token');

     if (to.meta.requiresAuth && !isAuthenticated) {
       next('/'); // Redirect to home page if not authenticated
     } else if (to.meta.guest && isAuthenticated) {
      next('/'); // Redirect to home if trying to access login/register while authenticated
    } else {
      next(); // Always call next() to resolve the hook
    }
  });

  return Router
})
